<template>
  <div class="pos-sidebar-header">
    <div class="back-btn">
      <button
        type="button"
        v-on:click="$emit('posMobileSidebarToggled')"
        class="btn"
      >
        <svg
          viewBox="0 0 16 16"
          class="bi bi-chevron-left"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
          />
        </svg>
      </button>
    </div>
    <div class="icon"><img src="@/assets/icon-table.svg" /></div>
    <div class="title">
      {{ $t('restaurantSale.table') }} {{ tableSelected.table_no }}
    </div>
    <div class="order">
      {{ $t('restaurantSale.order') }}:
      <b>#{{ tableSelected.order_no }}</b>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarHeader',
  props: {
    tableSelected: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>